import { useEffect, useRef } from "react";

/** Privacy-safe public availability invalidation channel.
 * Carries only {type:'availability.changed', module_id, at}.
 */
export function useAvailabilityEvents(handler) {
  const ref = useRef(handler);
  useEffect(() => { ref.current = handler; }, [handler]);
  useEffect(() => {
    let ws;
    let closed = false;
    let retry = 1000;
    let heartbeat;
    const open = () => {
      const url = window.location.origin.replace(/^http/, "ws") + "/api/ws/availability";
      try { ws = new WebSocket(url); } catch { schedule(); return; }
      ws.onopen = () => {
        retry = 1000;
        heartbeat = setInterval(() => { try { ws.send("ping"); } catch { /* noop */ } }, 25000);
      };
      ws.onmessage = (e) => { try { ref.current?.(JSON.parse(e.data)); } catch { /* noop */ } };
      ws.onclose = () => { if (heartbeat) clearInterval(heartbeat); if (!closed) schedule(); };
      ws.onerror = () => {};
    };
    const schedule = () => { if (!closed) { setTimeout(open, retry); retry = Math.min(retry * 2, 15000); } };
    open();
    return () => { closed = true; if (heartbeat) clearInterval(heartbeat); try { ws?.close(); } catch { /* noop */ } };
  }, []);
}
